<template>
    <FlexibleEditorContent :class="['body', { large: large }]" :content="body" :relation-blocks="relationBlocks" />
</template>

<script lang="ts" setup>
import FlexibleEditorContent from "directus-extension-flexible-editor/content/vue";
import { BlockRelationArticlesNodesImage, BlockRelationArticlesNodesYoutube } from "#components";

withDefaults(defineProps<{ body: any, large?: boolean }>(), {
    large: false
})

const relationBlocks: any = [
    { collection: "articles_nodes_image", component: BlockRelationArticlesNodesImage },
    { collection: "articles_nodes_youtube", component: BlockRelationArticlesNodesYoutube },
]
</script>